// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"48f8770b","513":"02be1554","545":"4751a0f3"}[chunkId] + ".chunk.js";
};